module.exports = __webpack_public_path__ + "static/img/tx1.f373c233.png";